import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios"


export default function TestimonialList() {


    const [testimonial, setTestimonial] = useState([]);

    // const testimonial = [
    //     {
    //         id: "1",
    //         name: "	Sarah K",
    //         designation: "Marketing Manager",
    //         image: "http://104.248.23.97:8100/uploads/website-images/admin.jpg",
    //         comment: "okay",
    //         status: "Inactive",
    //     },
    // ]



    useEffect(() => {
        fetchTestimonial();
    }, []);

    const fetchTestimonial = async () => {
        try {
            const response = await axios.get(
                `https://instructor.teachera.co/testimonial`,
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );
            setTestimonial(response.data.data);
        } catch (error) {
            console.log("error", error);
        }
    };

    return (
        <>
            <section className="main-sec">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="dashboard-title">
                            <h4 className="dash-head">
                                <i className="fa fa-chart-bar me-2" />
                                Testimonial List
                            </h4>
                        </div>
                        <div className="custom-bredcump">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Testimonials
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-lg-6 text-end">
                        <Link
                            to="add"
                            className="btn py-2 px-5 text-white btn-for-add"
                        >
                            <i className="fa fa-plus me-2"></i>
                            Add New
                        </Link>
                    </div>
                    <div className="col-lg-12">
                        <div className="cards bus-list">
                            <div className="bus-filter">
                                <div className="row ">
                                    <div className="col-lg-6">
                                        <h5 class="card-title">Testimonials List</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="table table-responsive custom-table">
                                <table className="table table-borderless">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>Rating</th>
                                            <th>Comment</th>
                                            {/* <th>Status</th> */}
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {testimonial.map((test, i) => {
                                            return (
                                                <tr key={test?._id}>
                                                    <td>{i + 1}</td>
                                                    <td>
                                                        <img src={`https://instructor.teachera.co/${test?.image} `} width={100} className="p-2" alt="Testimonial" />
                                                    </td>
                                                    <td>
                                                        <span>{test?.name}</span>
                                                    </td>
                                                    {/* <td>
                                                        <span>{test?.designation}</span>
                                                    </td> */}

                                                    <td>
                                                        <span>
                                                            {[...Array(5)].map((_, i) => (
                                                                <i
                                                                    key={i}
                                                                    className={`me-1 fa ${i < test?.rating ? 'fa-star' : 'fa-star-o'}`}
                                                                    style={{ color: '#ffc107' }}
                                                                ></i>
                                                            ))}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="cstm-wdth">{test?.content}</span>
                                                    </td>
                                                    {/* <td>
                                                        <button className={test.status === "Active" ? "btn btn-pill btn-primary    btn-sm" : "btn btn-pill btn btn-danger btn btn-sm"}>
                                                            <span>{test?.status === "Active" ? "Active" : "InActive"}</span>
                                                        </button>
                                                    </td> */}
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link
                                                                className="action-btn edit-btn"
                                                                to={`edit/${test?._id}`}
                                                                title="Edit"
                                                            >
                                                                <i className="fa fa-edit" />
                                                            </Link>
                                                            <button
                                                                className="action-btn delete-btn "
                                                                title="Delete"
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                                <span className="tooltip-text">Delete</span>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
